import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconOutput(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 19C3 20.11 3.9 21 5 21H19C20.1 21 21 20.1 21 19V18C21 17.45 20.55 17 20 17C19.45 17 19 17.45 19 18V19H5L5 5L19 5V6C19 6.55 19.45 7 20 7C20.55 7 21 6.55 21 6V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.89 3 5V19Z"
        fill="currentColor"
      />
      <path
        d="M20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L17.7071 15.7071C17.3166 16.0976 16.6834 16.0976 16.2929 15.7071C15.9024 15.3166 15.9024 14.6834 16.2929 14.2929L17.5858 13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11L17.5858 11L16.2929 9.70711C15.9024 9.31658 15.9024 8.68342 16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289L20.7071 11.2929Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
